import {useTranslation} from "react-i18next";

import FunctionButton from "../../utilities/Buttons/FunctionButton";
import KpFinTable from "../KP/kp-f/kpFinTable/KpFinTable";

import useKpFinHiddenColumns from "./useKpFinHiddenColumns";

import "./KpFinHiddenColumns.scss";

const KpFinHiddenColumns = () => {
  const {t} = useTranslation();
  const {initialSettings, isSaving, onResetClick, onSaveClick, onTableSettingsChange} = useKpFinHiddenColumns();

  return (
    <div className="hidden-columns-modal">
      <h2 className="hidden-columns-modal__title">{t("Column Settings for CO(f)")}</h2>
      <p className="hidden-columns-modal__description">
        {t("Here you can configure the column display template for CO(f)")}
      </p>

      <div className="hidden-columns-modal__table-wrap">
        <KpFinTable
          tableOnly
          forceEmptyData
          persistColumnOrder={false}
          initialSettings={initialSettings}
          onSettingsChange={onTableSettingsChange}
        />
      </div>

      <div className="hidden-columns-modal__actions">
        <FunctionButton name="Save" onClick={onSaveClick} autoWidth disabled={isSaving} />
        <FunctionButton name="Reset" onClick={onResetClick} autoWidth disabled={isSaving} />
      </div>
    </div>
  );
};

export default KpFinHiddenColumns;
